export const CHANNEL_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  UNAUTHORIZED: 'unauthorized',
  PENDING_PAYMENT: 'pending_payment',
  QR_IN_PROGRESS: 'qr_in_progress',
  AUTHORIZED: 'authorized',
  CONTACTS_SYNCED: 'contacts_synced',
  CHATS_SYNCED: 'chats_synced',
  READY: 'ready',
  PASSWORD_REQUIRED: 'password_required',
  REQUIRED_SCAN_QR: 'required_scan_qr',
  SMS_SENT: 'sms_sent',
  SUSPENDED: 'suspended',
} as const;

export const PROTOCOL = {
  TELEGRAM_PERSONAL: 'telegram_personal',
  TELEGRAM_BOT: 'telegram_bot',
  WHATSAPP_GRAY: 'whatsapp_gray',
  WABA: 'waba', // выдумано из головы - проверить наличие в API
  INFOBIP: 'infobip',
  MAX: 'max',
  MAX_PERSONAL: 'max_personal',
  AVITO: 'avito',
  WILDBERRIES: 'wildberries',
  OZON: 'ozon',
  VK: 'vk',
} as const;

export const CHANNELS = {
  TG_BOT: PROTOCOL.TELEGRAM_BOT,
  TG_PERSONAL: PROTOCOL.TELEGRAM_PERSONAL,
  WABA: 'waba',
  WHATSAPP_PERSONAL: PROTOCOL.WHATSAPP_GRAY,
} as const;

export const CHANNEL_NAME_MAP = {
  [PROTOCOL.TELEGRAM_BOT]: 'Telegram Bot',
  [PROTOCOL.TELEGRAM_PERSONAL]: 'Telegram Personal',
  [PROTOCOL.WABA]: 'WhatsApp Business Account',
  [PROTOCOL.WHATSAPP_GRAY]: 'WhatsApp Personal',
  [PROTOCOL.INFOBIP]: 'InfoBip',
  [PROTOCOL.MAX]: 'MAX',
  [PROTOCOL.MAX_PERSONAL]: 'MAX Personal',
  [PROTOCOL.AVITO]: 'Avito',
  [PROTOCOL.WILDBERRIES]: 'Wildberries',
  [PROTOCOL.OZON]: 'OZON',
  [PROTOCOL.VK]: 'VK',
} as const;

export const CHANNEL_SHORT_NAME_MAP = {
  [PROTOCOL.TELEGRAM_BOT]: 'Telegram Bot',
  [PROTOCOL.TELEGRAM_PERSONAL]: 'Telegram Personal',
  [PROTOCOL.WABA]: 'WABA',
  [PROTOCOL.WHATSAPP_GRAY]: 'WhatsApp',
  [PROTOCOL.INFOBIP]: 'InfoBip',
  [PROTOCOL.MAX]: 'MAX',
  [PROTOCOL.MAX_PERSONAL]: 'MAX Personal',
  [PROTOCOL.AVITO]: 'Avito',
  [PROTOCOL.WILDBERRIES]: 'Wildberries',
  [PROTOCOL.OZON]: 'OZON',
  [PROTOCOL.VK]: 'VK',
} as const;

export const CHANNEL_GROUP_TYPES = {
  whatsapp: 'whatsapp',
  telegram: 'telegram',
  max: 'max',
  avito: 'avito',
  wildberries: 'wildberries',
  ozon: 'ozon',
  vk: 'vk',
} as const;
